/**
 * Sample brands for the Games page (`?fixtures=1`, dev and preview only): the
 * Parlor's brand with its five slugs (one switched off, one the catalog does
 * not have) and Ben & Jerry's brand with an empty list (its app shows no
 * games), against the places pages' sample catalog. The write changes the
 * sample in memory only: nothing is sent anywhere.
 */
import { PARLOR_GAMES, sampleCatalogFor } from "@/features/places/fixtures";
import type { BrandGamesApi, BrandGamesRead } from "@/features/games/brand-games";

export const SAMPLE_BRANDS = {
  parlor: { name: "The Parlor", slugs: PARLOR_GAMES },
  "ben-and-jerrys": { name: "Ben & Jerry's", slugs: [] as string[] },
} as const;

export type SampleBrandKey = keyof typeof SAMPLE_BRANDS;

/** A sample brand's list and the sample catalog, as `isSuperAdmin` reads it. */
export function sampleBrandGamesRead(key: SampleBrandKey, isSuperAdmin: boolean): BrandGamesRead {
  return { slugs: [...SAMPLE_BRANDS[key].slugs], catalog: sampleCatalogFor(isSuperAdmin) };
}

/** The read and the write served from a sample, in memory: each write is kept
 *  in `sent` (for tests) and read back after; no network. */
export function fixtureBrandGamesApi(key: SampleBrandKey, isSuperAdmin: boolean): BrandGamesApi & { sent: string[][] } {
  let slugs = [...SAMPLE_BRANDS[key].slugs];
  const sent: string[][] = [];
  return {
    sent,
    read: async () => ({ ...sampleBrandGamesRead(key, isSuperAdmin), slugs: [...slugs] }),
    write: async (next) => {
      sent.push([...next]);
      slugs = [...next];
    },
  };
}
